module.exports = __webpack_public_path__ + "img/bell-alt-ring-p.8b044b8e.svg";